module.exports = __webpack_public_path__ + "c_static/img/1-3电脑淘宝收藏夹.541b032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/1-3电脑淘宝收藏夹.jpg
// module id = SqHi
// module chunks = 33